const APP_ENV = process.env.REACT_APP_ENV;
const NODE_ENV = process.env.NODE_ENV;

const getApiUrl = () => {
  let url;
  if (APP_ENV === 'production' || APP_ENV === 'dr') {
    url = `https://phoenix.rebelfoods.com/api`;
  } else if (APP_ENV === 'development') {
    url = 'http://localhost:3000/api';
  } else {
    url = `https://phoenix.${APP_ENV}.rebelfoods.com/api`;
  }
  return url;
};

const getPlatformUrl = () => {
  let url;
  if (APP_ENV === 'production' || APP_ENV === 'dr') {
    url = 'https://platform.rebelfoods.com';
  } else if (APP_ENV === 'development') {
    url = `https://platform.dev.rebelfoods.com`;
  } else {
    url = `https://platform.${APP_ENV}.rebelfoods.com`;
  }
  return url;
};

const setMongoConfig = (data) => {
  ConfigConstant.MONGO_CONFIG = data;
};

const ConfigConstant = {
  CODE_REBELPLUS: 'ODPT00002',
  BASE_API_URL: getApiUrl(),
  COMMON_ROUTE: getPlatformUrl(),
  PLATFORM_URL: getPlatformUrl(),
  LOGOUT_URL: `${getPlatformUrl()}/logout`,
  MONGO_CONFIG: {},
  CHANNEL_SWIGGY: 'swiggy',
  CODE_SWIGGY: 'ODCH00002',
  CODE_CAREEM: 'ODCH00012',
  CHANNEL_KEETA: 'keeta',
  CODE_KEETA: 'ODCH00023',
  FILTER_IDS_DIFF_COLOR: ['Group By'],
  FILTER_SELECT_TYPE: {
    SINGLE: 'single',
    MULTIPLE: 'multiple',
  },
  APP_ENV,
  NODE_ENV,
  PERMISSIONS: {
    outlet: {
      keys: ['createRead', 'createWrite', 'editRead', 'editWrite', 'bulkOperationsWrite'],
      values: [
        'CREATE_OUTLET_ACCESS_READ',
        'CREATE_OUTLET_ACCESS_WRITE',
        'UPDATE_OUTLET_ACCESS_READ',
        'UPDATE_OUTLET_ACCESS_WRITE',
        'BULK_OPERATIONS_ACCESS_WRITE',
      ],
    },
    phoenix: {
      keys: ['phoenixRead'],
      values: ['PHOENIX_READ'],
    },
    admin: {
      keys: ['isAdminWrite', 'isAdminRead'],
      values: ['ADMIN_ACCESS_WRITE', 'ADMIN_ACCESS_READ'],
    },
  },
};

export {ConfigConstant, setMongoConfig};
